// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"_3PV1ld","shine-lines":"_2_5aOm"};